/**
 * Measurement — registry entry (Component only; completeness is registered
 * separately in `modules/completeness.ts` per the A-01 split).
 */

import type { PfConfigModule } from '../registry'
import { Measurement } from './Measurement.component'

export const measurementModule: PfConfigModule = {
  flowId: 'measurement',
  Component: Measurement,
}
